module.exports = __webpack_public_path__ + "static/media/ic_school.aaa02bdd.svg";